import UserSymbol from './UserSymbol';
export default UserSymbol;
//# sourceMappingURL=index.js.map